import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { isListNode, isListItemNode } from './node';
import { getListItemAttributes } from './selection';
export var getCommonListAnalyticsAttributes = function getCommonListAnalyticsAttributes(state) {
  var _state$selection = state.selection,
    $from = _state$selection.$from,
    $to = _state$selection.$to;
  var fromAttrs = getListItemAttributes($from);
  var toAttrs = getListItemAttributes($to);
  return {
    itemIndexAtSelectionStart: fromAttrs.itemIndex,
    itemIndexAtSelectionEnd: toAttrs.itemIndex,
    indentLevelAtSelectionStart: fromAttrs.indentLevel,
    indentLevelAtSelectionEnd: toAttrs.indentLevel,
    itemsInSelection: countListItemsInSelection(state)
  };
};
export var countListItemsInSelection = function countListItemsInSelection(state) {
  var _state$selection2 = state.selection,
    from = _state$selection2.from,
    to = _state$selection2.to;
  if (from === to) {
    return 1;
  }
  var count = 0;
  var listSlice = state.doc.cut(from, to);
  listSlice.content.nodesBetween(0, listSlice.content.size, function (node, pos, parent, index) {
    if (parent && isListItemNode(parent) && !isListNode(node) && index === 0) {
      count++;
    }
  });
  return count;
};
export var RESTART_LISTS_ANALYTICS_KEY = 'restartListsAnalytics';
export var getRestartListsAttributes = function getRestartListsAttributes(tr) {
  var _tr$getMeta;
  return (_tr$getMeta = tr.getMeta(RESTART_LISTS_ANALYTICS_KEY)) !== null && _tr$getMeta !== void 0 ? _tr$getMeta : {};
};
export var storeRestartListsAttributes = function storeRestartListsAttributes(tr, attributes) {
  var meta = getRestartListsAttributes(tr);
  tr.setMeta(RESTART_LISTS_ANALYTICS_KEY, _objectSpread(_objectSpread({}, meta), attributes));
};